import axiosInstance from '@/services/axiosInstance'

async function createCoursePass (data) {
  const req = {
    url: '/rgcc-services/FuncionesSW/AltaPaseCursillista',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data?.return_value
}

async function createSportPass (data) {
  const req = {
    url: '/rgcc-services/FuncionesSW/AltaPaseDeportista',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data?.return_value
}

async function createAuxiliarPass (data) {
  const req = {
    url: '/rgcc-services/FuncionesSW/AltaPaseAuxiliar',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data?.return_value
}

export {
  createCoursePass,
  createSportPass,
  createAuxiliarPass
}
